// extracted by mini-css-extract-plugin
module.exports = {"sr-only":"gMpql","srOnly":"gMpql"};